(function () {
function $3216735320b4c519$export$d16800b7e59a8051(selector, parent = document) {
    const ELEMENT = parent.querySelector(selector);
    if (ELEMENT === null) throw new Error(`Element with selector '${selector}' is not found!`);
    return ELEMENT;
}


function $44aceb9ff6d07541$var$init() {
    const FORM = (0, $3216735320b4c519$export$d16800b7e59a8051)("#newsletter-form");
    const EMAIL_FIELD = (0, $3216735320b4c519$export$d16800b7e59a8051)("#email", FORM);
    const EMAIL_ERROR_FIELD = (0, $3216735320b4c519$export$d16800b7e59a8051)("#email-error", FORM);
    const SUBSCRIBE_PAGE = (0, $3216735320b4c519$export$d16800b7e59a8051)("#subscribe-page");
    const SUCCESS_PAGE = (0, $3216735320b4c519$export$d16800b7e59a8051)("#success-page");
    const USER_EMAIL_LINK = (0, $3216735320b4c519$export$d16800b7e59a8051)("#user-email", SUCCESS_PAGE);
    const DISMISS_BUTTON = (0, $3216735320b4c519$export$d16800b7e59a8051)("#dismiss-button");
    FORM.addEventListener("submit", function(event) {
        event.preventDefault();
        if (this.checkValidity()) {
            console.log("Form id valid.");
            EMAIL_FIELD.classList.remove("field--error");
            EMAIL_ERROR_FIELD.textContent = "";
            USER_EMAIL_LINK.textContent = EMAIL_FIELD.value;
            SUBSCRIBE_PAGE.classList.replace("lg:flex", "hidden");
            SUCCESS_PAGE.classList.replace("hidden", "grid");
        } else {
            EMAIL_FIELD.classList.add("field--error");
            const { typeMismatch: typeMismatch, valueMissing: valueMissing } = EMAIL_FIELD.validity;
            let message = "";
            if (valueMissing) message = "Email required";
            else if (typeMismatch) message = "Valid email required";
            EMAIL_ERROR_FIELD.textContent = message;
            EMAIL_FIELD.focus();
        }
    });
    DISMISS_BUTTON.addEventListener("click", function() {
        console.log("Success page dismissed.");
        SUBSCRIBE_PAGE.classList.replace("hidden", "lg:flex");
        SUCCESS_PAGE.classList.replace("grid", "hidden");
        EMAIL_FIELD.value = "";
    });
}
$44aceb9ff6d07541$var$init();

})();
//# sourceMappingURL=index.26f74cea.js.map
